export default {
  path: 'inputInvoice',
  meta: {
    title: '进项发票'
  },
  component: () => import('@/components/parent-view'),
  name: 'inputInvoice',
  children: [
    {
      path: 'purchase',
      meta: {
        title: '未收票采购订单'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'inputInvoice-purchase',
          meta: {
            title: '未收票采购订单',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/inputInvoice/purchase/index.vue')
        },
        {
          path: 'detail',
          name: 'inputInvoice-purchase-detail',
          meta: {
            title: '未收票采购订单详情'
          },
          component: () => import('@/view/v5/inputInvoice/purchase/detail.vue')
        }
      ]
    },
    {
      path: 'management',
      meta: {
        title: '进项发票管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          name: 'inputInvoice-management',
          meta: {
            title: '进项发票管理',
            ignoreBreadCrumb: true
          },
          component: () => import('@/view/v5/inputInvoice/management/index.vue')
        },
        {
          path: 'add',
          name: 'inputInvoice-management-add',
          meta: {
            title: '进项发票新增'
          },
          component: () => import('@/view/v5/inputInvoice/management/add.vue')
        },
        {
          path: 'detail',
          name: 'inputInvoice-management-detail',
          meta: {
            title: '进项发票详情'
          },
          component: () =>
            import('@/view/v5/inputInvoice/management/detail.vue')
        },
        {
          path: 'correction',
          name: 'inputInvoice-management-correction',
          meta: {
            title: '进项发票纠错'
          },
          component: () =>
            import('@/view/v5/inputInvoice/management/correction.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/inputInvoice.js